import React from "react";
import { useNavigate } from "react-router-dom";
import "./StudentAboutUs.css";

const policySections = [
  {
    title: "About Us",
    content:
      "Our institution is committed to quality education, transparent communication, and student-first digital services. This page provides important information related to payment gateway usage, privacy, terms, and refund policy.",
  },
  {
    title: "School Address",
    content: [
      "School Campus Address, City, State, PIN Code, India.",
      "Phone: +91-XXXXXXXXXX",
      "Email: support@school.edu",
    ],
  },
  {
    title: "Payment Gateway",
    content:
      "All online fee payments are processed through the official payment gateway integrated with this portal. Students are advised to verify details before completing the payment.",
  },
  {
    title: "Privacy Policy",
    content:
      "We collect only required student and payment information to deliver academic and administrative services. Your data is used for institutional operations and is protected as per applicable policies.",
  },
  {
    title: "Terms And Conditions",
    content:
      "By using this portal, students agree to submit accurate information, comply with institutional rules, and use payment services only for legitimate fee transactions.",
  },
  {
    title: "Payment Refund Policy",
    content:
      "All payments made through the portal are final. No refund will be provided once a payment is successfully processed.",
  },
];

const StudentAboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid student-about-page">
      <div className="row">
        <div className="col-12">
          <div className="student-about-shell">
            <div className="student-about-header">
              <h2 className="student-about-title">About Us And Policies</h2>
              <button
                type="button"
                className="btn btn-danger student-about-close"
                onClick={() => navigate("/student/dashboards")}
              >
                Close
              </button>
            </div>

            <div className="student-about-sections">
              {policySections.map((section) => (
                <section key={section.title} className="student-about-card">
                  <div className="student-about-card-title">{section.title}</div>
                  <div className="student-about-card-body">
                    {Array.isArray(section.content) ? (
                      section.content.map((line) => (
                        <div key={line} className="student-about-line">
                          {line}
                        </div>
                      ))
                    ) : (
                      <p className="student-about-copy">{section.content}</p>
                    )}
                  </div>
                </section>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentAboutUs;
